import type { ProjectAssetsModel, TransProgress } from '@ve-pro/api/aside/type'
import { AssetStatus } from '@ve-pro/enums/asset'
import { handleAssetProgress } from '../aside/config/aside-methods'

interface AssetTask {
  task: Promise<TransProgress>
  resolve: (value: TransProgress) => void
}

// 正在检测状态的资源id
const checkingAssetTasks = new Map<ProjectAssetsModel['asset_id'], AssetTask>()

// 资源添加-转码进度
export async function checkAssetProgress(
  asset: ProjectAssetsModel,
): Promise<TransProgress> {
  let task = checkingAssetTasks.get(asset.asset_id)

  if (!task) {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    let _resolve: AssetTask['resolve'] = () => {}

    const _task: AssetTask['task'] = new Promise((resolve) => {
      _resolve = resolve
    })

    task = {
      task: _task,
      resolve: _resolve,
    }

    checkingAssetTasks.set(asset.asset_id, task)
  }

  check()

  return task.task
}

let isChecking = false
let timer: ReturnType<typeof setTimeout>

function check() {
  if (isChecking) {
    return
  }

  clearTimeout(timer)
  isChecking = true
  const assetIds = Array.from(checkingAssetTasks.keys())

  handleAssetProgress(assetIds)
    .then((res) => {
      const data = res.data.data ?? []
      data.forEach((progress) => {
        const task = checkingAssetTasks.get(progress.id)
        if (
          ![AssetStatus.Pending, AssetStatus.Transcoding].includes(
            progress.status,
          ) &&
          task
        ) {
          task.resolve(progress)
          checkingAssetTasks.delete(progress.id)
        }
      })
    })
    .finally(() => {
      isChecking = false
      if (checkingAssetTasks.size > 0) {
        timer = setTimeout(check, 5 * 1000)
      }
    })
}
